import React from "react";
import ExlyModal from "common/Components/ExlyModal";
import { Form } from "react-final-form";
import styles from "./AffliateDiscountModal.module.css";
import AddAffliateDiscount from "../AddAffliateDiscount";
import { useAddAffliateDiscount } from "../utils/useAddAffliateDiscount";
import { useShowDiscountCodesModal } from "../../AffliateDiscount/utils/useShowDiscountCodesModal";
import { useGetAffiliateUuid } from "features/AffiliateMarketing/utils/useGetAffiliateUuid";
import { DISCOUNT_TYPE } from "../../AffliateDiscount/constants/affliateDiscount.constants";

const AddAffliateDiscountModal = () => {
  const { affiliateUuid } = useGetAffiliateUuid();
  const handleClose = (form) => {
    form.reset();
    closeDiscountCodesModal();
  };
  const { closeDiscountCodesModal, showDiscountCodesModal } =
    useShowDiscountCodesModal();
  const initialValues = {
    type: DISCOUNT_TYPE.PERCENTAGE,
    affiliate_uuid: affiliateUuid,
  };
  const { handleAddAffliateDiscountCode, processing } =
    useAddAffliateDiscount();

  return (
    <>
      <Form
        onSubmit={handleAddAffliateDiscountCode}
        initialValues={initialValues}
        render={({ handleSubmit, form, submitting }) => (
          <ExlyModal
            open={showDiscountCodesModal}
            onClose={() => handleClose(form)}
            title={"Create Affiliate Discount Code"}
            onPrimaryBtnClick={handleSubmit}
            primaryBtnText={processing ? processing : "Create Affiliate Code"}
            primaryBtnProps={{
              type: "submit",
              disabled: submitting,
              loading: submitting,
            }}
            modal_props={{
              modalPaperClassName: styles.desktopModalPaper,
            }}
            mobile_modal_props={{}}
            className={`p-0`}
          >
            <div className={`px-3`}>
              <form onSubmit={handleSubmit}>
                <AddAffliateDiscount />
              </form>
            </div>
          </ExlyModal>
        )}
      />
    </>
  );
};

export default AddAffliateDiscountModal;
